import React, { useEffect, useState } from "react";
import { get, getElectionNews } from "../functions";
import { IoMdStar } from "react-icons/io";
import { ElectionNews, Loader, UnAuth } from "../components";

const CandidateList = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unauth, setUnAuth] = useState(false);
  const [electionNews, setElectionNews] = useState({
    text: "",
    imageUrl: "",
    createdBy: {},
    styles: {},
  });

  const getCandidates = async () => {
    const response = await get("/public/candidates-list");
    if (response?.status === "Success") {
      setPositions(response.data);
    } else if (
      response?.status === "Error" &&
      response?.message === "Unauthorized access."
    ) {
      setUnAuth(true);
    }
  };

  const getLookups = async () => {
    await getCandidates();
    await getElectionNews(setElectionNews);
    setLoading(false);
  };

  useEffect(() => {
    getLookups();
  }, []);

  if (unauth) {
    return <UnAuth />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <main className="gap-8 !p-10 grid grid-cols-1 md:grid-cols-[47%_50%]">
      <section>
        <h1 className="heading">Candidate List</h1>
        {positions.map((position, ind) => (
          <section key={ind} className="section mb-8 !w-full !p-5">
            <h2 className="heading !mb-5">{position.position}</h2>
            <section className="flex justify-center items-center gap-4 flex-wrap">
              {position?.candidate?.map((candidate, index) => (
                <div
                  key={index}
                  className="bg-brown text-white p-2 rounded text-center flex justify-between items-center gap-1 max-sm:w-full"
                >
                  <IoMdStar />
                  {candidate.name}
                  <IoMdStar />
                </div>
              ))}
            </section>
          </section>
        ))}
      </section>
      <ElectionNews electionNews={electionNews} />
    </main>
  );
};

export default CandidateList;
